import { useMemo } from "react";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { useParams } from "react-router-dom";

export const useCareRecipientIdFromPath = (): CareRecipientId | null => {

    const { careRecipientId } = useParams<PathParams>();

    if (!careRecipientId) {
        return null;
    }

    return useMemo<CareRecipientId>(() => {
        return CareRecipientId.fromString(careRecipientId);
    }, [careRecipientId]);
};

type PathParams = {
    careRecipientId: string
}